import React, { createContext, useState, useEffect } from 'react';
import { colorHexMap } from '../colorlibrarygarments'; // Import colorHexMap from the file

export const ColorContext = createContext();

export const ColorProvider = ({ children }) => {
  const [selectedColor, setSelectedColor] = useState('#B2BEB5'); // Default color code (Ash Grey)
  const [selectedColorName, setSelectedColorName] = useState('Ash Grey'); // Default color name
  const [selectedSizes, setSelectedSizes] = useState([]); // Track the sizes for the selected color

  useEffect(() => {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const colorId = params.get('colorId'); // Extract colorId from URL

    if (colorId) {
      const matchedColor = Object.keys(colorHexMap).find(
        (color) => colorHexMap[color]?.id === colorId
      );

      if (matchedColor) {
        setSelectedColor(colorHexMap[matchedColor].hex);
        setSelectedColorName(matchedColor);
      }
    }
  }, []);

  const updateColorIdInUrl = (colorId) => {
    const params = new URLSearchParams(window.location.search);
    params.set('colorId', colorId); // Update the colorId parameter
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl); // Use replaceState to avoid adding to the browser's history stack
  };

  const value = {
    selectedColor,
    selectedColorName,
    setSelectedColor,
    setSelectedColorName,
    setSelectedSizes,
    selectedSizes,
    updateColorIdInUrl, // Expose the function in the context
  };

  return (
    <ColorContext.Provider value={value}>
      {children}
    </ColorContext.Provider>
  );
};
